<template>
  <div id="body-content">
    <Download id="ca5-section1" />
    <Steps id="ca5-section2" />
    <div class="container-fluid">
      <Form id="ca5-section3" />
    </div>
    <Video id="ca5-section4" />
  </div>
</template>

<script>
import Download from './components/Download'
import Steps from './components/Steps'
import Form from './components/Form'
import Video from './components/Video'

export default {
  name: 'App',
  components: {
    Download,
    Steps,
    Form,
    Video
  }
}
</script>

<style lang="scss">
  @import "./assets/style";

  #footer_tc_privacy_text p {
    color: white;
  }
  .el-checkbox {
    white-space: normal ;

    .el-checkbox__label {
      float: right;
      width: calc(100% - 20px);
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue